/** Stable property definition IDs from the backend seed migrations. */
export const SYSTEM_PROPERTY_IDS = {
  ASSIGNEES: '00000001-0000-0000-0000-000000000001',
  STATUS: '00000001-0000-0000-0000-000000000002',
  PRIORITY: '00000001-0000-0000-0000-000000000003',
  DUE_DATE: '00000001-0000-0000-0000-000000000004',
  PARENT_TASK: '00000001-0000-0000-0000-000000000005',
  SUBTASKS: '00000001-0000-0000-0000-000000000006',
  DEPENDS_ON: '00000001-0000-0000-0000-000000000007',
  EFFORT: '00000001-0000-0000-0000-000000000008',
  STORY_POINTS: '00000001-0000-0000-0000-000000000009',
  RELEVANT_DOCUMENTS: '00000001-0000-0000-0000-00000000000a',
  SOURCE: '00000001-0000-0000-0000-00000000000b',
  COMPANIES: '00000001-0000-0000-0000-00000000000c',
  SENDER: '00000001-0000-0000-0000-00000000000d',
  RECIPIENTS: '00000001-0000-0000-0000-00000000000e',
  SUBJECT: '00000001-0000-0000-0000-00000000000f',
  STAGE: '00000001-0000-0000-0000-000000000010',
  COMPANY_OWNER: '00000001-0000-0000-0000-000000000011',
  REVENUE: '00000001-0000-0000-0000-000000000012',
  CONTACTS: '00000001-0000-0000-0000-000000000013',
  /** The one project (initiative) a task belongs to. */
  PROJECT: '00000001-0000-0000-0000-000000000014',
} as const;

/** Stable option IDs, kept independent of UI/block registries for tooling. */
export const PROPERTY_OPTION_IDS = {
  PRIORITY: {
    LOW: '00000001-0000-0000-0003-000000000001',
    MEDIUM: '00000001-0000-0000-0003-000000000002',
    HIGH: '00000001-0000-0000-0003-000000000003',
    URGENT: '00000001-0000-0000-0003-000000000004',
  },
  STATUS: {
    NOT_STARTED: '00000001-0000-0000-0002-000000000001',
    IN_PROGRESS: '00000001-0000-0000-0002-000000000002',
    IN_REVIEW: '00000001-0000-0000-0002-000000000003',
    COMPLETED: '00000001-0000-0000-0002-000000000004',
    CANCELED: '00000001-0000-0000-0002-000000000005',
  },
  STAGE: {
    LEAD: '00000001-0000-0000-0010-000000000001',
    QUALIFIED: '00000001-0000-0000-0010-000000000002',
    DEMO: '00000001-0000-0000-0010-000000000003',
    TRIAL: '00000001-0000-0000-0010-000000000004',
    NEGOTIATION: '00000001-0000-0000-0010-000000000005',
    CUSTOMER: '00000001-0000-0000-0010-000000000006',
    CHURNED: '00000001-0000-0000-0010-000000000007',
  },
} as const;
